import { MAX_INVENTORY_QUANTITY } from './inventoryInputs';

export const canOrderOnDemand = (product, isAdmin) => Boolean(isAdmin) &&
  ['ACTIVE', 'PREORDER', 'OUT_OF_STOCK', 'SOLD_OUT'].includes(product.state);

const count = value => Math.max(0, Number(value) || 0);

export function availableOrderQuantity(product) {
  return count(product.maxQuantity ?? product.quantity);
}

export const basketQuantityLimit = (product, isAdmin) => canOrderOnDemand(product, isAdmin)
  ? MAX_INVENTORY_QUANTITY : availableOrderQuantity(product);

export function prepareCheckoutProducts(products, isAdmin) {
  return products.map(product => {
    const toOrder = canOrderOnDemand(product, isAdmin) && product.quantity > availableOrderQuantity(product);
    return Boolean(product.toOrder) === toOrder ? product : { ...product, toOrder };
  });
}

export function orderAvailability(product) {
  const requested = count(product.quantity);
  const available = availableOrderQuantity(product);
  const physical = product.stockQuantity != null ? count(product.stockQuantity)
    : product.state === 'PREORDER' ? 0 : available;
  const future = product.preorderQuantity != null ? count(product.preorderQuantity)
    : product.state === 'PREORDER' ? available : 0;
  const stock = Math.min(requested, physical);
  const ordered = Math.min(requested - stock, future);
  return { stock, ordered, toOrder: Math.max(0, requested - stock - ordered) };
}
